
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import {
  Lead, LeadType, StepNames, Task, User,
} from '@/types';
import { canResetTask } from '@/helpers';

@Component
export default class TaskStatusAlert extends Vue {
  @Prop(Object) readonly task: Task | undefined;
  @Prop(String) readonly step: StepNames | undefined;
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;
  @Prop({ type: Boolean, default: false }) readonly embedded!: boolean;
  @Prop({ type: Boolean, default: false }) readonly showActions!: boolean;

  // La Lead selezionata memorizzata tramite Vuex
  get selectedLead(): Lead | null {
    return this.$store.getters.currentLead;
  }

  get selectedTask(): Task | null {
    // Se non è stato specificato un Task nelle Prop,
    // utilizza il Task selezionato memorizzato tramite Vuex.
    return this.task ?? this.$store.getters.selectedTask;
  }

  get leadType(): LeadType | null {
    return this.selectedLead?.type ?? null;
  }

  // Sto caricando il Task
  get loading(): boolean {
    return this.$store.getters.isTaskLoading;
  }

  // Sto aggiornando il Task
  get updating(): boolean {
    return this.$store.getters.isTaskUpdating;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get isSuperUser(): boolean {
    return this.user && this.user.isSuperUser;
  }

  get isOpen(): boolean {
    if (this.selectedTask) return this.selectedTask.status === null;
    if (this.step && this.selectedLead) return this.selectedLead[this.step] === null;
    return false;
  }

  get isComplete(): boolean {
    if (this.selectedTask) return this.selectedTask.status === 'completed';
    if (this.step && this.selectedLead) return this.selectedLead[this.step] === true;
    return false;
  }

  get isFailed(): boolean {
    if (this.selectedTask) return this.selectedTask.status === 'error';
    if (this.step && this.selectedLead) return this.selectedLead[this.step] === false;
    return false;
  }

  get canResetTask(): boolean {
    return canResetTask(this.selectedTask, this.selectedLead);
  }

  get canEditTask(): boolean {
    return !this.readonly;
  }

  get currentLeadStatus() {
    return this.isCurrentProject
      ? this.selectedLead?.status
      : this.leadInfo?.status;
  }

  get isCurrentProject(): boolean {
    return Boolean(
      this.selectedLead && this.task && this.selectedLead.id === (this.task.childLeadId ?? this.task.LeadId),
    );
  }

  get leadInfo(): Lead | null {
    if (this.leadId
      && this.leadId in this.childLeads) return this.childLeads[this.leadId];

    if (this.leadId && this.selectedLead
      && this.selectedLead.id === this.leadId) return this.selectedLead;

    return null;
  }

  get leadId(): number | null {
    if (this.task?.childLeadId && this.task.childLeadId) return this.task.childLeadId;

    // if (this.lead && this.lead.id) return this.lead.id;

    return this.task?.LeadId || null;
  }

  get childLeads() {
    // return this.$store.getters.currentChildren;
    return this.$store.getters.currentChildrenInfo;
  }

  onEdit() {
    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    this.$emit('edit');
  }

  onReset() {
    console.log(`${this.constructor.name}: onReset()`); // eslint-disable-line no-console

    this.$emit('reset');
  }
}
